<template>
  <div class="welcome-container">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>

<script>
import WelcomeDefault from './Welcome_Default.vue'
import WelcomeHeNan from './Welcome_HeNan.vue'
import WelcomeHaiNan from './Welcome_HaiNan.vue'
export default {
  name: 'Welcome',
  components: {
    WelcomeDefault,
    WelcomeHeNan,
    WelcomeHaiNan
  },
  data () {
    return {
      layout: '',
      ready: false
    }
  },
  mounted () {
    if (this.$route.params.region === 'henan') {
      this.layout = 'WelcomeHeNan'
      this.ready = true
    } else {
      // this.$router.replace('/welcome/henan')
      if (this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']) {
        this.layout = `Welcome${this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']}`
        this.ready = true
      } else {
        this.layout = 'WelcomeDefault'
        this.ready = true
      }
    }
    // if (this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']) {
    //   this.layout = `Welcome${this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']}`
    //   this.ready = true
    // } else {
    //   this.layout = 'WelcomeDefault'
    //   this.ready = true
    // }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.welcome-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
